import React from "react";
import { Col, Row } from "react-flexbox-grid";
import { Link } from "gatsby";
import * as styles from "./styles.module.css";

const PhotosRow = ({ sections }) => {
  return (
    <Row className="photo-row">
      {sections?.map((i) => (
        <Col
          key={i}
          md={4}
          className={styles.backgroundDiv}
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${i.r?.image?.r?.field_image?.localFile.publicURL})`,
          }}
        >
          <Link key={i} to={i.section_link.uri}>
            <div className={styles.innerContainer}>
              <h3 className={styles.title}>{i.section_title}</h3>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: i.description.processed,
                }}
              ></div>
              <div className={styles.link}>{i.section_link.title} &#8594;</div>
            </div>
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default PhotosRow;
